import CloseIcon from "@mui/icons-material/Close";

export function DeleteEmployeeMemoForm({ isOpen, onClose, handleDelete }) {
  return (
    <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
      {isOpen && (
        <div className="modal">
          <div className="popUp-header row">
            <div className="popUp-title">
              <h3 style={{ color: "#668fca" }}>Delete Employee Memo</h3>
            </div>
            <div className="popUp-close">
              <CloseIcon onClick={onClose} />
            </div>
          </div>
          <div className="popUp-body" style={{ display: "flex", alignItems: "center", justifyContent: "center", padding: "20px" }}>
            <span>Are you sure you want to delete this employee memo? This action cannot be undone.</span>
          </div>
          <div className="buttons row" style={{ justifyContent: "center", padding: "40px 40px 20px 40px" }}>
            <button className="save row" onClick={handleDelete} style={{ marginRight: "5px", backgroundColor: "#DD5746" }}>
              DELETE
            </button>
            <button className="cancel row" onClick={onClose}>
              CANCEL
            </button>
          </div>
        </div>
      )}
    </div>
  );
}